document.addEventListener('DOMContentLoaded', () => {
    const initZoom = () => {
        const images = document.querySelectorAll('swiper-container[id^="Slider-Gallery-"] .product__media img');
        
        images.forEach(img => {
            if (img.dataset.zoomInitialized) return;
            img.dataset.zoomInitialized = 'true';

            const container = img.closest('.product__media');
            if (!container) return;
            
            container.style.overflow = 'hidden';
            // Make sure the image transform origin is centered
            img.style.transformOrigin = 'center center';
            img.style.willChange = 'transform'; // hardware acceleration

            let currentScale = 1;
            let currentX = 0;
            let currentY = 0;
            
            let isZooming = false;
            let startDistance = 0;
            let initialScale = 1;
            
            let isPanning = false;
            let startX = 0;
            let startY = 0;
            let initialX = 0;
            let initialY = 0;
            
            let lastTap = 0;

            const updateTransform = (transition = false) => {
                img.style.transition = transition ? 'transform 0.3s ease-out' : 'none';
                img.style.transform = `translate(${currentX}px, ${currentY}px) scale(${currentScale})`;
            };

            const resetZoom = () => {
                currentScale = 1;
                currentX = 0;
                currentY = 0;
                updateTransform(true);
                const slide = container.closest('swiper-slide');
                if(slide) slide.classList.remove('swiper-no-swiping');
            };

            container.addEventListener('touchstart', (e) => {
                if (window.innerWidth >= 768) return; // Only mobile
                
                // Double tap logic
                if (e.touches.length === 1) {
                    const currentTime = new Date().getTime();
                    const tapLength = currentTime - lastTap;
                    
                    if (tapLength < 300 && tapLength > 0) {
                        e.preventDefault();
                        if (currentScale > 1) {
                            resetZoom();
                        } else {
                            currentScale = 2.5;
                            updateTransform(true);
                            const slide = container.closest('swiper-slide');
                            if(slide) slide.classList.add('swiper-no-swiping');
                        }
                        lastTap = 0; // reset
                        return;
                    }
                    lastTap = currentTime;

                    if (currentScale > 1) {
                        isPanning = true;
                        startX = e.touches[0].clientX;
                        startY = e.touches[0].clientY;
                        initialX = currentX;
                        initialY = currentY;
                    }
                }

                // Pinch zoom logic
                if (e.touches.length === 2) {
                    isZooming = true;
                    isPanning = false;
                    const touch1 = e.touches[0];
                    const touch2 = e.touches[1];
                    startDistance = Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);
                    initialScale = currentScale;
                }
            });

            container.addEventListener('touchmove', (e) => {
                if (window.innerWidth >= 768) return;
                
                if (isZooming && e.touches.length === 2) {
                    e.preventDefault();
                    e.stopPropagation(); // Prevent swiper from moving
                    
                    const touch1 = e.touches[0];
                    const touch2 = e.touches[1];
                    const currentDistance = Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);
                    
                    currentScale = initialScale * (currentDistance / startDistance);
                    // clamp scale between 1 and 4
                    currentScale = Math.max(1, Math.min(currentScale, 4));
                    
                    if (currentScale > 1) {
                        const slide = container.closest('swiper-slide');
                        if(slide) slide.classList.add('swiper-no-swiping');
                    }
                    
                    // Adjust panning bounds during pinch
                    const maxX = (container.offsetWidth * currentScale - container.offsetWidth) / 2;
                    const maxY = (container.offsetHeight * currentScale - container.offsetHeight) / 2;
                    currentX = Math.max(-maxX, Math.min(maxX, currentX));
                    currentY = Math.max(-maxY, Math.min(maxY, currentY));
                    
                    updateTransform(false);
                } else if (isPanning && e.touches.length === 1 && currentScale > 1) {
                    e.preventDefault();
                    e.stopPropagation(); // Prevent swiper from moving
                    
                    const moveX = e.touches[0].clientX - startX;
                    const moveY = e.touches[0].clientY - startY;
                    
                    currentX = initialX + moveX;
                    currentY = initialY + moveY;
                    
                    // Simple bounds clamping
                    const maxX = (container.offsetWidth * currentScale - container.offsetWidth) / 2;
                    const maxY = (container.offsetHeight * currentScale - container.offsetHeight) / 2;
                    
                    currentX = Math.max(-maxX, Math.min(maxX, currentX));
                    currentY = Math.max(-maxY, Math.min(maxY, currentY));
                    
                    updateTransform(false);
                }
            }, { passive: false });

            container.addEventListener('touchend', (e) => {
                if (window.innerWidth >= 768) return;
                
                if (e.touches.length < 2) {
                    isZooming = false;
                }
                if (e.touches.length === 0) {
                    isPanning = false;
                    if (currentScale <= 1) {
                        resetZoom();
                    }
                }
            });
        });
    };

    initZoom();

    // Support dynamic updates (e.g. variants changing)
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, () => {
            setTimeout(initZoom, 300);
        });
    }

    const galleryContainer = document.querySelector('.product-media-gallery');
    if (galleryContainer) {
        const observer = new MutationObserver((mutations) => {
            let shouldReinit = false;
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length > 0) {
                    shouldReinit = true;
                }
            });
            if (shouldReinit) {
                // The initZoom() is idempotent, so it is safe to call it again
                setTimeout(initZoom, 200);
            }
        });
        observer.observe(galleryContainer, { childList: true, subtree: true });
    }
});
